import { render } from "./ListMessage.vue?vue&type=template&id=3c02b617&scoped=true"
import script from "./ListMessage.vue?vue&type=script&lang=js"
export * from "./ListMessage.vue?vue&type=script&lang=js"

import "./ListMessage.vue?vue&type=style&index=0&id=3c02b617&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c02b617"]])

export default __exports__